<template>
  <generic-modal :title="$t('buy promotion')" ref="generic_modal">
    <div>
      <div class="title is-5">{{ meta.name }}</div>
      <div class="field">
        <generic-dropdown
          :title="$t('choosen promotion')"
          :placeholder="$t('select one')"
          :is_multiple="false"
          url="/pilates_member/promotion/catalog"
          name_field="name"
          value_field="promotion_id"
          @selected="promotion_changed"
          ref="promotion_dropdown"
        />
      </div>
      <div class="field is-grouped is-grouped-multiline">
        <div class="control">
          <div
            class="tags are-medium has-addons"
            v-if="promotion && promotion.settings && promotion.settings.price"
          >
            <span class="tag is-dark">{{ $t("price") }}</span>
            <span class="tag is-info">{{
              format_currency(promotion.settings.price)
            }}</span>
          </div>
        </div>
        <div class="control">
          <div
            class="tags are-medium has-addons"
            v-if="
              promotion && promotion.settings && promotion.settings.hours_to_add
            "
          >
            <span class="tag is-dark">{{
              promotion.settings.hours_to_add
            }}</span>
            <span class="tag is-success">{{
              $t("extra membership hours")
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        :class="{ 'is-loading': is_loading }"
        @click="save"
        :disabled="is_form_invalid || is_loading"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  format_currency,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "BuyPromotionModal",
  components: { GenericModal, GenericCalendar, GenericDropdown },
  data() {
    return {
      promotion: {},
      meta: {},
      error: "",
      is_loading: false,
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name || !v.meta.promotion_id;
    },
  },
  methods: {
    format_currency,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(member) {
      let v = this;
      v.set_initial_state();
      v.meta.name = member.name;
      v.meta.pilates_member_id = member.pilates_member_id;
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      v.is_loading = true;
      put("/pilates_member/promotion/buy", v.meta)
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.is_loading = false;
        });
    },
    set_initial_state() {
      let v = this;
      v.promotion = {};
      v.meta = {
        name: "",
        pilates_member_id: "",
        promotion_id: "",
        settings: {},
      };
      v.error = "";
      v.is_loading = false;
      v.$refs.promotion_dropdown.clear();
      // v.uuid = "";
    },
    promotion_changed(promotion) {
      let v = this;
      if (promotion) {
        v.promotion = promotion;
        v.meta.promotion_id = promotion.promotion_id;
      }
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
